// extracted by mini-css-extract-plugin
module.exports = {"iconItemList":"IconItem-module--iconItemList--UoJ2W","iconItem":"IconItem-module--iconItem--rOY5f","iconItemWrapper":"IconItem-module--iconItemWrapper--2VEm3"};